import type { FaceDetection } from "@/libs/cv"
import type { Rect } from "@/libs/geometry/types"

/**
 * Returns detection with adjusted bounding box in the visible rect coordinates
 *
 * @param detections - Face detection from face mesh module
 * @param visibleRect - Visible rect in the original frame coordinates in absolute pixels
 * @param frame - Whole frame dimensions in absolute pixels
 */
export const adjustDetectionBoundingBoxToVisibleRect = (
  { boundingBox, ...detection }: FaceDetection,
  visibleRect: Rect,
  { width, height }: Omit<Rect, "x" | "y">,
): FaceDetection => {
  const [w, h] = [width / visibleRect.width, height / visibleRect.height]

  return {
    ...detection,
    boundingBox: {
      x: (-(visibleRect.x / width) + (1 - boundingBox.x - boundingBox.width)) * w,
      y: (-(visibleRect.y / height) + boundingBox.y) * h,
      width: boundingBox.width * w,
      height: boundingBox.height * h,
    },
  }
}
